module.exports = __webpack_public_path__ + "a17d279f/img/google.68f3823e.svg";